/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown>, members: NonNullable<unknown> }} Pricing_Titan_Size_UptoInputs */



/**
* | output |
* | --- |
* | "{price} up to {members} members" |
*
* @param {Pricing_Titan_Size_UptoInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_titan_size_upto = /** @type {((inputs: Pricing_Titan_Size_UptoInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Titan_Size_UptoInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.price} — до ${i?.members} участников`)
	return /** @type {LocalizedString} */ (`${i?.price} up to ${i?.members} members`)
});